import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { OptionFilter } from '@periscopes/general/filters';
import { SonarTagDisplay } from '@ui/tags';
import { SonarText } from '@ui/text';
import { Tag } from 'antd';
import { useTags } from '@hooks';

import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';

export const TagsFilter: FilterComponent<Array<number>> = (props) => {
	const { format, id, onChange, value } = props;

	const tags = useTags();

	const sortedTags = useMemo(() => {
		const tagMap = tags.map((tag) => ({
			label: tag.name,
			value: tag.id
		}));

		tagMap.unshift({
			label: COPY_SPECIFIC.NO_TAGS,
			value: -1
		});

		return tagMap;
	}, [ tags ]);

	return (
		<FilterComponent
			{ ...props }
			label={ COPY_SPECIFIC.TAGS }
			tagProps={ {
				value: sortedTags
					.filter((option) => value?.includes(option.value))
					.map((option) => option.label)
					.join(', ')
			} }>
			<OptionFilter
				className='filter'
				getPopupContainer={ getDirectParent }
				id={ getFilterId(id) }
				maxTagCount='responsive'
				mode='multiple'
				onChange={ (tagIds: Array<number>) =>
					onChange({
						[ id ]: {
							format,
							value: tagIds
						}
					}) }
				optionRender={ (renderProps) =>
					(Number(renderProps.value) === -1 ?
						<SonarText>{ COPY_SPECIFIC.NO_TAGS }</SonarText> :
						<SonarTagDisplay
							noBorder
							noClick
							tagId={ Number(renderProps.value) } />) }
				options={ sortedTags }
				placeholder={ PLACEHOLDERS_COPY.FILTER_BY_TAG }
				showArrow
				tagRender={ (renderProps) => {
					if (renderProps.value === -1) {
						return <Tag>{ COPY_SPECIFIC.NO_TAGS }</Tag>;
					}

					return <SonarTagDisplay tagId={ renderProps.value } />;
				} }
				value={ value } />
		</FilterComponent>
	);
};
